import { Page } from '@rammetec/design-system'
import type { AppModuleInstance } from '@vectorhub/domain'
import { useCurrentModule } from '@/app/modules/CurrentModuleContext'

export interface GenericModulePageProps {
  instance: AppModuleInstance
}

export function GenericModulePage({ instance }: GenericModulePageProps) {
  const moduleDef = useCurrentModule()
  const title = instance.label ?? moduleDef?.label ?? instance.slug
  return (
    <Page
      name={`vectorhub.module.generic.${instance.id}`}
      title={title}
      description="Este módulo ainda não está disponível nesta versão."
      productArea="vectorhub"
    />
  )
}
